<button type="button" class="call-modal__close" (click)="cancel()">
  <mat-icon svgIcon="close"></mat-icon>
  <span class="call-modal__close-label">{{ 'NGX-MESSAGING.close' | translate }}</span>
</button>
<div class="call-modal">
  <messaging-avatar [name]="data.client.displayName" [initialsSize]="2" size="80"> </messaging-avatar>
  <h2>{{ data.client.displayName }}</h2>
  <p>{{ 'NGX-MESSAGING.CALL-RECIVE.IsCallingYou' | translate }}</p>
  <div class="call-modal__options">
    <button type="button" (click)="cancel()" class="call-modal__btn call-modal__btn--decline">
      <mat-icon svgIcon="call_end"></mat-icon>
    </button>
    <button type="button" (click)="goCall()" class="call-modal__btn call-modal__btn--accept">
      <mat-icon svgIcon="call"></mat-icon>
    </button>
  </div>
</div>
